// Google Consent Mode v2 helpers.
// Defaults are initialized as "denied" in public/index.html before any Google script loads.

const STORAGE_KEY = "litiodata_cookie_consent";

function gtag() {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(arguments);
}

export function readConsent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

export function saveConsent(prefs) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...prefs, ts: Date.now() }));
  } catch (e) {
    /* ignore */
  }
}

// prefs: { analytics: boolean, marketing: boolean }  (necessary is always granted)
export function updateConsent(prefs) {
  const analytics = prefs.analytics ? "granted" : "denied";
  const marketing = prefs.marketing ? "granted" : "denied";

  gtag("consent", "update", {
    ad_storage: marketing,
    ad_user_data: marketing,
    ad_personalization: marketing,
    analytics_storage: analytics,
  });

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: "cookie_consent_update" });
}

// Re-apply a stored decision on load without re-pushing the interaction event noise.
export function applyStoredConsent(prefs) {
  updateConsent(prefs);
}

export { STORAGE_KEY };
